import InvoicesFilter from "@/components/invoices";

export function InvoicesMenu() {
	/** Render */
	return <InvoicesFilter />;
}
